import { connect } from 'react-redux';

import { Entities, fetchAll, fetchAllCustomRepository, getEntities, patch, save } from 'src/common/index';
import CancellationsOverviewAdministrations from 'src/components/admin/cancellations-overview/cancellations-overview-administration';

const mapStateToProps = state => {
    return {
        cancellations: getEntities(state, Entities.CANCELLATION_INFOS),
    };
};

const CancellationsOverviewAdministrationContainer = connect(mapStateToProps, {
    fetchAll,
    fetchAllCustomRepository,
    patch,
    save,
})(CancellationsOverviewAdministrations);

export default CancellationsOverviewAdministrationContainer;
